/* Build-in libraries */

/* Third party libraries */
import { CogIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import { authSelector, useAppSelector } from '@/store';
//Services
import { useDashboardWidgetListUpdate, useDashboardWidgetsList } from '../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../types/Analytics';
/* Components */
import SlideOver from '../UI/SlideOver';
import type { WidgetListInterface } from '../Widgets/types';
//Assets and miscellaneous
import { widgetsIcon } from './constant';
import DashboardWidgetList from './DashboardWidgetList';

export interface WidgetAccordionInterface {
  dashboard: DashboardType;
}

function DashboardWidget({ dashboard }: WidgetAccordionInterface) {
  const { fetchDashboardWidgets } = useDashboardWidgetsList({
    dashboard,
  });
  const dashboardWidgets = fetchDashboardWidgets?.data;
  const widgetList = dashboardWidgets?.[0]?.widgets?.map((wdg: any) => ({
    ...wdg,
    icon: widgetsIcon[wdg.slug],
  }));

  const [openModal, setOpenModal] = useState(false);

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const openModalHandler = () => {
    setOpenModal(true);
  };

  const updateUserDashboardList = useDashboardWidgetListUpdate({
    dashboard,
  });

  const submitHandler = (id: number, status: boolean) => {
    const usedStatus = !status;
    const usedWidgetList = widgetList
      .map((item: WidgetListInterface) => {
        if (item.id === id) {
          return { ...item, isUsed: usedStatus };
        } else {
          return item;
        }
      })
      .filter((data: WidgetListInterface) => data.isUsed)
      .map((item: WidgetListInterface) => {
        return { widgetId: item.id };
      });

    const finalData = {
      widgets: usedWidgetList,
      dashboardType: dashboard,
    };
    updateUserDashboardList.mutate(finalData);
  };

  const { data } = useAppSelector(authSelector);
  const HIDDEN_WIDGETS = ['TOTAL_PROJECTS', 'TOTAL_PROGRAMS'];
  const filteredWidgets = widgetList?.filter(
    (widget: any) => !(data.account === 'birminghamhousing' && HIDDEN_WIDGETS.includes(widget.slug))
  );

  return (
    <div className='flex justify-end text-neutralColor-medium  transition duration-300 ease-in-out'>
      <div className='bg-green-500 cursor-pointer h-8 w-8 flex justify-center items-center rounded-lg hover:bg-primaryColor-medium transition duration-300 ease-in-out'>
        <CogIcon className='h-6 w-6  text-white' onClick={openModalHandler} />
      </div>
      <div className='absolute top-16 right-0 bg-white h-full'>
        <SlideOver
          slideOverHandler={closeModalHandler}
          slideOver={openModal}
          search={false}
          title='Dashboard Widgets'
          subtitle='Manage widgets on the dashboard from below available widgets'
        >
          <div className='h-screenWidgets overflow-y-auto px-6'>
            {filteredWidgets?.map((data: any, _index: number) => (
              <DashboardWidgetList
                id={data.id}
                name={data.name}
                description={data.description}
                isButtonLoading={updateUserDashboardList.isLoading}
                icon={data.icon}
                key={data.id}
                isUsed={data.isUsed}
                onSubmit={submitHandler}
              />
            ))}
          </div>
        </SlideOver>
      </div>
    </div>
  );
}

export default DashboardWidget;
